import React from "react";
import { useTranslation } from "react-i18next";

import { TextSection } from "../../components/expretise/TextSection";
import DomainesIntervention from "../../components/expretise/DomainesIntervention";
import SlideGenerale from "../../components/expretise/slideGenarale";
import SEO from "../../components/SEO";

import img from "../../assets/images/bg-.png";
import text from "../../assets/images/add.png";

import { CercleIcon } from "../../assets/icons/CercleIcon";
import { Parametre } from "../../assets/icons/Parametre";
import { CardIcon } from "../../assets/icons/CardIcon";

export const Advisory = () => {
  const { t } = useTranslation();

  const cards = [
    {
      id: 1,
      icon: <CardIcon />,
      title: t("advisory.cards.card1.title"),
      description: t("advisory.cards.card1.description"),
      backContent: t("advisory.cards.card1.backContent", {
        returnObjects: true,
      }),
    },
    {
      id: 2,
      icon: <CercleIcon />,
      title: t("advisory.cards.card2.title"),
      description: t("advisory.cards.card2.description"),
      backContent: t("advisory.cards.card2.backContent", {
        returnObjects: true,
      }),
    },
    {
      id: 3,
      icon: <Parametre />,
      title: t("advisory.cards.card3.title"),
      description: t("advisory.cards.card3.description"),
      backContent: t("advisory.cards.card3.backContent", {
        returnObjects: true,
      }),
    },
    {
      id: 4,
      icon: <CardIcon />,
      title: t("advisory.cards.card4.title"),
      description: t("advisory.cards.card4.description"),
      backContent: t("advisory.cards.card4.backContent", {
        returnObjects: true,
      }),
    },
    {
      id: 5,
      icon: <CercleIcon />,
      title: t("advisory.cards.card5.title"),
      description: t("advisory.cards.card5.description"),
      backContent: t("advisory.cards.card5.backContent", {
        returnObjects: true,
      }),
    },
    {
      id: 6,
      icon: <Parametre />,
      title: t("advisory.cards.card6.title"),
      description: t("advisory.cards.card6.description"),
      backContent: t("advisory.cards.card6.backContent", {
        returnObjects: true,
      }),
    },
  ];

  return (
    <div>
      <SEO
        title="MSIT Services - Centre de Services et Solutions Technologiques"
        description="MSIT Services propose un centre de services technologiques complet avec des solutions d'externalisation, de gestion d'infrastructure et de support technique."
        keywords="centre de services, MSIT services, solutions technologiques, externalisation IT, support technique"
        url="https://www.msit-conseil.fr/bu-msit-services"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "MSIT Services", url: "https://www.msit-conseil.fr/bu-msit-services" }
        ]}
      />
      <SlideGenerale
        headerBg="bg-dark"
        bgColor="bg-primary"
        sectionClass="consulting-section"
        bgImage={img}
        heightBg="consulting-section-height"
        infos={[
          {
            label: t("advisory.infos.info1.label"),
            value: t("advisory.infos.info1.value"),
          },
          {
            label: t("advisory.infos.info2.label"),
            value: t("advisory.infos.info2.value"),
          },
          {
            label: t("advisory.infos.info3.label"),
            value: t("advisory.infos.info3.value"),
          },
        ]}
        title={t("advisory.title")}
        description={t("advisory.description")}
      />
      <TextSection image={text} />
      <DomainesIntervention cards={cards} />
    </div>
  );
};
